import { createContext, useContext } from 'react';

/**
 * An enumeration for the possible values of text direction
 *  - LTR represents left-to-right scripts and should be used by default
 *  - RTL represents right-to-left scripts (currently Arabic and Hebrew are supported)
 */
export type TextDirection = 'ltr' | 'rtl';

export const TextDirectionContext = createContext<TextDirection>('ltr');

export const useTextDirection = () => useContext(TextDirectionContext);

export function TextDirectionProvider({
    children,
    textDirection,
}: {
    children: React.ReactNode;
    textDirection: TextDirection;
}) {
    return (
        <TextDirectionContext.Provider value={textDirection}>
            {children}
        </TextDirectionContext.Provider>
    );
}
